<template>
    <div class="activityDetail">
        <h1>{{activity_list.title}}</h1>
        <p>{{$t("activity_time")+':'+activity_list.start_time+"-"+activity_list.end_time}}</p>
        <div class="activityDetail_content" v-html="this.replaceHtml(activity_list.content)"></div>

        <!--<div class="activityDetail_content" v-html="htmlDecode(activity_list.content.replace(/\/public/g,'http://m.indoorlink.com/r.php?url='+weburl+'/public'))"></div>
        --><!--<div style='width: 100%;text-align: center;margin: 75px 0 ;'><img
                src='../../assets/images/no_page.png' alt='' width="160"></div>-->
    </div>
</template>

<script>
export default {
  name: "activityDetail",
  inject: ["replaceHtml", "showMsg"],
  created: function() {
    this.getActivityDetailInfo(this.$route.params.id);
    this.$store.commit("set_current", "3");
    this.$store.commit("set_title", "nav.activity");
  },
  methods: {
    getActivityDetailInfo(id) {
      this.$http({
        method: "post",
        url: this.weburl + "/home/Information/getInformation",
        dataType: "json",
        data: {
          id: id,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.$store.commit("set_activity_list", res.data.result);
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    }
  },
  computed: {
    activity_list: function() {
      return this.$store.state.activity.activity_list;
    },
    weburl: function() {
      return this.$store.state.weburl;
    },
    current: function() {
      return this.$store.state.home.current;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";

.activityDetail {
  width: @width;
  .box-sizing;
  padding: 20px 20px 10px;
  & > h1 {
    font-size: @font + 0.4;
    line-height: @font * 2;
    margin-bottom: 10px;
  }
  & > p {
    margin-bottom: 10px;
    font-size: @font;
    padding-bottom: 10px;
    .border-bottom;
  }
}
</style>
<style scoped>
.activityDetail_content >>> img {
  width: 100%;
}
.activityDetail_content video {
  width: 100% !important;
  height: 100%;
}
.activityDetail_content {
  line-height: 24px !important;
}
</style>
